import React from 'react';
import './CalendarLegend.css';

const CalendarLegend = ({items}) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <ul className="calendar-legend" aria-label="Legenda do calendário">
            {items.map(({key, swatchClass, label}) => (
                <li key={key} className="calendar-legend__item">
                    <span
                        className={`calendar-legend__swatch ${swatchClass}`.trim()}
                        aria-hidden="true"
                    />
                    <span className="calendar-legend__label">{label}</span>
                </li>
            ))}
        </ul>
    );
};

export default CalendarLegend;
